<template>
	<section class="section top-opportunities">
		<div class="container mx-auto px-4">

			<div class="top-opportunities__header">
				<svg class="top-opportunities__header-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 81 82"><path fill="#24B4D0" fill-rule="evenodd" d="M19.784 65.278c-5.215-8.213-11.573-16.819-9.02-26.225 3.563-13.118 10.858-28.298 24.362-30.277 13.597-1.992 24.18 10.955 32.248 21.982 6.295 8.602 10.188 20.159 5.677 29.848-3.779 8.116-15.595 5.786-23.88 9.252-5.19 2.17-8.97 7.675-14.518 6.81-6.51-1.014-11.353-5.854-14.87-11.39z" clip-rule="evenodd" opacity=".7"/><path fill="#F6F7F8" d="M52.304 36.624c0-2.89-3.03-3.238-3.656-3.342l.174-2.299-.453-.209H33.744l-.243.14v2.193c-.662.105-3.97.732-3.935 3.343 0 0-.21 2.368.975 3.796.766.905 2.472 1.671 4.527 1.74.313.976 1.114 1.568 1.81 1.95 0 0-.104-.138.87.558 1.603 1.114 1.603 1.846 1.672 2.333v.383c0 .801-.07 1.254-.07 1.88h-2.158l-.662.523-.209 2.855s9.193.314 9.193-.07c0-.313-.209-2.333-.209-3.064 0-.139-.348-.244-.348-.244h-2.194v-.034l-.035-1.846c0-.278.035-1.393 1.393-2.368.453-.278.836-.696 1.497-1.08 0 0 .21-.069.453-.278.453-.313.766-.487 1.219-1.393 2.333-.034 3.552-.905 4.213-2.193.766-1.428.801-3.274.801-3.274zm-21.102.105s.314-1.88 2.612-1.985l.696 5.363c-.975.209-2.158-.07-2.75-.906-.384-.522-.523-1.532-.558-2.472zm16.54 3.517c.035-.244.07-.488.07-.731l.627-4.806c1.985 0 2.368 2.02 2.368 2.02-.105 1.01-.21 1.845-.592 2.403-.662.87-1.95 1.114-2.472 1.114z"/></svg>
				<div class="top-opportunities__header-wrapper">
          XXXXXXXXXXXXXXXXXXX
					<h2 class="top-opportunities__header-title"><slot name="title"></slot></h2>
					<p class="top-opportunities__header-text"><slot name="subtitle"></slot></p>
				</div>
			</div>

			<!-- <block-newsletter-subscribe-top-10></block-newsletter-subscribe-top-10> -->

			<!-- <home-top-opportunities-cards :payload="payload" :column="column" :card_color="card_color"></home-top-opportunities-cards> -->
      <block-top-opportunities-cards :payload="payload"></block-top-opportunities-cards>

      <div class="top-opportunities__btn-group">
        <a class="btn btn-blue-dark" href="/search/discover" aria-label="Discover all opportunities">Discover all opportunities?!?!</a>
      </div>

			<!-- <a class="btn btn-blue-dark" href="/search/discover">Discover all opportunities</a> -->

		</div>
	</section>
</template>

<script>
// import TopOpportunitiesCards from './partials/TopOpportunitiesCards';
// import HomeTopOpportunitiesCards from './partials/HomeTopOpportunitiesCards';

export default {
	// components: {
  // 	TopOpportunitiesCards,
  //   HomeTopOpportunitiesCards
	// },

	props: {
		payload: {
			type: [Object, Array, String]
		},
		column: {
			type: Boolean
		},
		card_color: {
			type: String
		},
	}
}
</script>
